/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Swedish (sv) string table
   English is the source of truth in the HTML; this file supplies the
   Swedish counterpart for each data-i18n key. Missing keys fall back to
   English automatically (see i18n.js). Hand this file to a translator or
   compliance reviewer; it is the single place Swedish copy lives.

   House voice: calm, exact, short. No em dashes (use periods, commas,
   or the mid-dot · ). Product names (Transderma C/A/O/M/R, Discovery
   Kit, Moisture Serum) stay in English.
═════════════════════════════════════════════════════════════════════ */
window.TD_I18N = window.TD_I18N || {};
window.TD_I18N.sv = Object.assign(window.TD_I18N.sv || {}, {

  /* ── Nav (site-wide) ── */
  'nav.shop': 'Butik',
  'nav.science': 'Vetenskap',
  'nav.concerns': 'Hudbehov',
  'nav.story': 'Vår historia',
  'nav.contact': 'Kontakt',
  'nav.tryus': 'Prova oss',
  'nav.faq': 'Vanliga frågor',
  'nav.drawerCta': 'Prova oss · Discovery Kit',
  'nav.drawerFine': 'Fem vitaminserum · $70 · skickas världen över',

  /* ── Announcement bar (site-wide) ── */
  'announce.0a': '<strong>Fri frakt</strong> på alla beställningar över $150',
  'announce.0b': 'Levereras världen över från Stockholm',
  'announce.1a': '<strong>Bygg en rutin &amp; spara 10%</strong>',
  'announce.1b': 'Dras automatiskt i kassan',
  'announce.2a': 'Prova alla fem serum.',
  'announce.2b': '<strong>Fri frakt över $150</strong>',

  /* ── Homepage · hero ── */
  'home.hero.tagline': 'Hudvård utan kompromiss · Est. 1998',
  'home.hero.h1': '<span class="l1">Inget vatten.</span><br><span class="l2">Inga konserveringsmedel.</span><br><span class="l3">Inga tillsatser.</span><br><span class="l4">Inga färgämnen.</span><br><span class="l5">Ingen luft.</span><br><span class="l6"><em class="hero-vitamins-em">Bara aktiva vitaminer.</em></span>',
  'home.hero.sub': 'Formulerade för verklig dermal absorption bortom ytan.<br>Fem vitaminserum. Fem nej. Ett system.',
  'home.hero.cta1': 'Utforska serumen',
  'home.hero.cta2': 'Så fungerar det',

  /* ── Homepage · coming-soon teaser (static only) ── */
  'home.cs.title': 'Kampanj<br><em>Sommaren</em> 2026',
  'home.cs.shop': 'Serum tillgängliga nu',

  /* ── Homepage · press bar ── */
  'home.press.label': 'Omskrivna i',

  /* ── Homepage · collection ── */
  'home.coll.eyebrow': 'Kollektionen',
  'home.coll.h2': 'Precisionsformulerade vitaminserum. <em>Utvecklade i Stockholm.</em>',
  'home.coll.viewAll': 'Visa alla produkter',
  'home.coll.c.benefit': 'Skyddar, ger lyster och stärker med rent C-vitamin.',
  'home.coll.a.benefit': 'Retinoldriven förnyelse medan du sover.',
  'home.coll.o.benefit': 'Ger energi åt cellerna och återställer synlig lyster.',
  'home.coll.m.benefit': 'Reparerar fuktbarriären. Djupt och varaktigt.',
  'home.coll.r.benefit': 'Stärker och återställer. Reducerar synligheten av orenheter, postakneärr och ojämn struktur över tid.',
  'home.coll.kit.name': 'Discovery Kit',
  'home.coll.kit.benefit': 'Alla fem serum i fickformat. Prova hela systemet innan du bestämmer dig.',
  'home.coll.kit.badge': 'Nyhet',

  /* ── Homepage · science intro (shared) ── */
  'home.science.eyebrow': 'Vetenskapen',
  'home.science.h2': 'Djup leverans är<br><em>skillnaden.</em>',
  'home.science.body': 'Transdermas leveranssystem bär aktiva vitaminer förbi epidermis ner i dermis, där kollagensyntes och cellförnyelse sker.',
  'home.science.readMore': 'Läs hela vetenskapen →',

  /* ── Homepage · science skin diagram (static only) ── */
  'home.sci.serumLabel': 'Transderma<br>Serum',
  'home.sci.l1.label': 'STRATUM CORNEUM',
  'home.sci.l1.desc': 'Hudens yttersta lager',
  'home.sci.l1.p': 'Stratum corneum är hudens yttre barriär: döda, packade celler som blockerar det mesta av det vi applicerar. Transdermas vattenfria formula absorberas igenom det inom sekunder efter applicering. Aktiva vitaminer når den levande vävnaden under intakta, utan att något går förlorat till avdunstning.',
  'home.sci.l1.depth': '0 mm DJUP',
  'home.sci.l2.label': 'EPIDERMIS',
  'home.sci.l2.desc': 'Levande hudceller, melanocyter, nervändar',
  'home.sci.l2.p': 'De flesta serum stannar här, avlagrade bland epidermis levande celler, oförmögna att gå längre. Transderma innehåller inget vatten, så varje droppe behåller sin fulla vitaminkoncentration under färden. Inget späds ut på vägen; formulan fortsätter mot dermis.',
  'home.sci.l2.depth': '0,1 mm DJUP',
  'home.sci.l2.stop': 'De flesta serum stannar här',
  'home.sci.barrier': 'HUDBARRIÄR',
  'home.sci.l3.label': 'DERMALT LAGER',
  'home.sci.l3.desc': 'Kollagen, elastin, fibroblaster, blodkärl',
  'home.sci.l3.p': 'Dermis är där varaktig hudförändring faktiskt skapas: kollagen, elastin och cellförnyelse börjar här. Transderma för koncentrerade vitaminer direkt in i detta lager, där fibroblaster kan ta dem i bruk. Detta är lagret som konventionella serum sällan når, och anledningen till att våra resultat syns över veckor.',
  'home.sci.l3.depth': '1–2 mm DJUP',
  'home.sci.l4.label': 'SUBKUTAN VÄVNAD',
  'home.sci.l4.desc': 'Fettvävnad och djupt strukturellt stöd',
  'home.sci.l4.p': 'Under dermis ligger det subkutana lagret, fettvävnad som förankrar huden och håller dess form. Vid detta djup har Transdermas vitaminer redan tagits upp av dermis ovanför. Vävnaden här är den strukturella grunden för den förnyelse som sker i varje lager byggt ovanpå den.',
  'home.sci.l4.depth': '4–10 mm DJUP',
  'home.sci.reach': 'TRANSDERMA NÅR HIT',

  /* ── Homepage · purity / five nos (static + theme strip) ── */
  'home.purity.eyebrow': 'Skillnaden',
  'home.purity.h2': 'Inte vad<br><em>du förväntar dig.</em>',
  'home.purity.water.title': 'Inget vatten',
  'home.purity.water.body': 'Vattenfri formula. Högre koncentration, djupare leverans.',
  'home.purity.preserv.title': 'Inga konserveringsmedel',
  'home.purity.preserv.body': 'Utan vatten kan mikrober inte växa. Inga behövs.',
  'home.purity.fillers.title': 'Inga tillsatser',
  'home.purity.fillers.body': 'Varje ingrediens är funktionell. Inga emulgeringsmedel, förtjockningsmedel eller bulkfyllnadsmedel.',
  'home.purity.dyes.title': 'Inga färgämnen',
  'home.purity.dyes.body': 'Tonen du ser kommer från råa aktiva ämnen, inte tillsatt färg.',
  'home.purity.air.title': 'Ingen luft',
  'home.purity.air.body': 'Förseglad i en lufttät pump. Full styrka, från första droppen till sista.',

  /* ── Homepage · pure formulation strip header (liquid only) ── */
  'home.strip.eyebrow': 'Ren formulering',
  'home.strip.h3': 'Bara aktiva vitaminer.<br><em>Inget annat.</em>',

  /* ── Homepage · trust commitments (liquid only) ── */
  'home.trust.cruelty': '<strong>Aldrig testat på djur.</strong> Djurfri sedan första dagen.',
  'home.trust.vegan': '<strong>Veganska formuleringar.</strong> Inga djurbaserade ingredienser.',
  'home.trust.made': '<strong>Tillverkat i Stockholm.</strong> Labbgodkänt av Läkemedelsverket.',
  'home.trust.eu': '<strong>EU-kosmetikaregistrerat.</strong> Säljs på kliniker i 14 länder.',

  /* ── Homepage · airless section (liquid only) ── */
  'home.airless.eyebrow': 'Lufttät design',
  'home.airless.h2': 'Förseglad från första pumptrycket<br><em>till det sista.</em>',
  'home.airless.body': 'Luft är det som åldrar ett serum. Den lufttäta pumpen stänger den dörren. Sista droppen har samma styrka som den första.',

  /* ── Homepage · sample / discovery kit ── */
  'home.sample.eyebrow': 'Vet inte var du ska börja?',
  'home.sample.h2': 'Prova alla fem<br><em>för $70.</em>',
  'home.sample.body': 'Transderma Discovery Kit innehåller fickformat av alla fem serum och en tryckt guide för att bygga din rutin. Det är så de flesta av våra långsiktiga kunder först hittade oss.',
  'home.sample.bodyTheme': 'Transderma Discovery Kit innehåller fickformat av alla fem serum. Det är så de flesta av våra långsiktiga kunder först hittade oss.',
  'home.sample.cta': 'Skaffa Discovery Kit',
  'home.sample.fine': '$5 frakt · Inkluderar tryckt hudbehovsguide',
  'home.sample.fineTheme': '$5 frakt världen över · Skickas från Stockholm',
  'home.sample.f1.h': 'Alla fem serum',
  'home.sample.f1.p': 'Fickformat och perfekta för dig som är på språng. Cirka 7 dagars konsekvent användning.',
  'home.sample.f1.pTheme': 'Fickformat 3 ml-flaskor, perfekta för dig som är på språng. Cirka 7 dagars konsekvent användning per flaska.',
  'home.sample.f2.h': 'Hudbehovsguide',
  'home.sample.f2.p': 'En tryckt guide som hjälper dig hitta vilka serum som passar dina specifika behov.',
  'home.sample.f2.hTheme': 'Alla fem, sida vid sida',
  'home.sample.f2.pTheme': 'Kör varje formula genom din rutin samma vecka och hitta kombinationerna som fungerar för din hud.',
  'home.sample.f3.h': 'Inga åtaganden',
  'home.sample.f3.p': 'Ta reda på om Transderma passar dig. De flesta vet inom några dagar.',

  /* ── Homepage · skin concerns ── */
  'home.conc.eyebrow': 'Hitta din formula',
  'home.conc.h2': 'Handla efter<br><em>hudbehov.</em>',
  'home.conc.firm.t': 'Fasthet',
  'home.conc.firm.d': 'Förlust av elasticitet och definition längs käklinjen och kinderna.',
  'home.conc.bright.t': 'Lyster',
  'home.conc.bright.d': 'Ojämn ton, matthet och missfärgning från miljöexponering, ärrbildning eller postakneärr.',
  'home.conc.hydrate.t': 'Återfuktning',
  'home.conc.hydrate.d': 'Torr hud, fjällning och en försvagad fuktbarriär som inte håller.',
  'home.conc.lines.t': 'Fina linjer',
  'home.conc.lines.d': 'Ytliga linjer och djupare uttrycksrynkor som utvecklas över tid.',
  'home.conc.viewAll': 'Visa alla hudbehov →',

  /* ── Homepage · heritage / founder ── */
  'home.her.caption': 'Dr. Klaus Alvin Ronlán, Ph.D.<br><span>1942 — 2018 · Docent</span>',
  'home.her.eyebrow': 'Grundaren',
  'home.her.h2': 'Trettio år.<br><em>Samma formula.</em>',
  'home.her.body': 'Transderma föddes i ett laboratorium i Stockholm, grundat av Dr. Klaus Alvin Ronlán efter tjugofem års forskning vid Lunds universitet. Fem serum, lanserade 1998. Förvaltade oförändrade sedan Dr. Ronlán gick bort 2018. Fortfarande oberoende ägt. Fortfarande tillverkat i Sverige.',
  'home.her.bodyTheme': 'Transderma föddes i ett laboratorium i Stockholm, grundat av Dr. Klaus Alvin Ronlán efter tjugofem års forskning. Fortfarande oberoende ägt. Fortfarande tillverkat i Sverige.',
  'home.her.cta': 'Läs Dr. Ronláns berättelse →',

  /* ── Awards · Recognition (site-wide) ── */
  'awards.label': 'Belönad',
  'awards.serumC': 'Nordic Natural Beauty Awards · Vinnare 2020',
  'awards.serumA': 'Global Makeup Awards · Silver, Skandinavien 2022',
  'awards.serumO': 'Swedish Beauty &amp; Cosmetics Awards · Vinnare 2016',
  'awards.serumM': 'Nordic Natural Beauty Awards · Vinnare 2020',
  'awards.serumR': 'ELLE Sweden Beauty Awards · Vinnare 2013',
  'awards.fullLine': 'Belönad av · ELLE Sweden Beauty Awards · Nordic Natural Beauty Awards · Swedish Beauty &amp; Cosmetics Awards · Global Makeup Awards · LUXlife Magazine',
  'awards.aboutLine': 'Belönad · ELLE Sweden 2013 · Swedish Beauty &amp; Cosmetics 2016 · Nordic Natural Beauty 2020 · Global Makeup 2022 · LUXlife 2021',

  /* ── Press pull-quotes (real editorial reviews) ── */
  'quote.home.text': '"Mycket effektiv hudvård, när den är som bäst."',
  'quote.home.cite': 'Melissa Davis · The Beauty Librarian',
  'quote.serumR.text': '"Som magi för huden. Mitt pigmenteringsproblem på överläppen försvann."',
  'quote.serumR.cite': 'Teresa Grundin · Styleby, 2014',
  'quote.serumC.text': '"Vetenskapen bakom produkten och formelns enkelhet är imponerande."',
  'quote.serumC.cite': 'Truth In Aging',
  'quote.serumA.text': '"Maximal hudvård. Transderma A och C."',
  'quote.serumA.cite': 'Teresa Grundin · Elle.se, 2014',

  /* ── Footer (site-wide) ── */
  'footer.tagline': 'Est. 1998 · Stockholm',
  'footer.location': 'Stockholm, Sverige',
  'footer.col.serums': 'Serum',
  'footer.col.shop': 'Butik',
  'footer.col.learn': 'Lär dig mer',
  'footer.col.support': 'Kundtjänst',
  'footer.serums.kit': 'Discovery Kit',
  'footer.serums.gift': 'Presentkort',
  'footer.shop.all': 'Alla serum',
  'footer.learn.research': 'Dr. Ronláns forskning',
  'footer.learn.science': 'Vetenskapen',
  'footer.learn.concerns': 'Hudbehov',
  'footer.learn.story': 'Vår historia',
  'footer.learn.about': 'Om Dr. Ronlán',
  'footer.support.faq': 'Vanliga frågor',
  'footer.support.shipping': 'Frakt &amp; returer',
  'footer.support.stockists': 'Återförsäljare',
  'footer.support.contact': 'Kontakt',
  'footer.support.privacy': 'Integritet',
  'footer.support.terms': 'Villkor',
  'footer.copy': '© 2026 Transderma®. Alla rättigheter förbehållna. Stockholm, Sverige.<svg class="ft-flag" viewBox="0 0 16 10" xmlns="http://www.w3.org/2000/svg" aria-label="Sverige"><rect width="16" height="10" fill="#006AA7"/><rect x="5" width="2" height="10" fill="#FECC00"/><rect y="4" width="16" height="2" fill="#FECC00"/></svg>',
  'footer.links.privacy': 'Integritet',
  'footer.links.terms': 'Villkor',

  /* ── Certifications strip (homepage) ── */
  'certifications.label': 'Certifieringar',
  'certifications.ewg': 'EWG Verifierad',
  'certifications.certclean': 'CertClean Certifierad'

});
